angular = require('angular')
pkg = angular
  .module 'common.resource', [require("angular-resource")]
  .factory 'RestfulResource', require("./restful/resource")  
  .directive 'restfulResources', require('./restful/directive')
  .directive 'collectionResources', require('./collection')
  .directive 'paginator', require('./paginator')  
  .directive 'sort', require('./sortor')
     
module.exports = pkg.name


// WEBPACK FOOTER //
// ./src/common/resource/index.coffee